import { getCookie, deepClone } from 'smbls'
import { DS_DEFAULTS, DATA_DEFAULTS, SETTINGS_DEFAULTS } from './defaults'

const [, embed] = window.location.pathname.split('/')
const isEmbed = embed === 'embed'

const urlParams = new URLSearchParams(window.location.search)
const globalTheme = urlParams.get('globalTheme')
const followingUser = urlParams.get('followingUser')
const selected = urlParams.get('selected')

// @preserve-env
const ENV = process.env.NODE_ENV

export const state = {
  isRootState: true,
  isEmbed,
  // shareRootStateOnCanvas: true,

  ENV: getCookie('ENV') || ENV || 'development',
  // DEFAULTS: {
  //   DS_DEFAULTS,
  //   DATA_DEFAULTS,
  //   SETTINGS_DEFAULTS
  // },

  // ...deepClone(DATA_DEFAULTS),
  // schema: deepClone(DATA_DEFAULTS),

  canvas: {
    clients: {},
    pages: {}
  },

  settings: {
    remote: false,
    async: false,
    inspect: true,
    liveSync: true,
    syncCanvas: true
  },

  sampleText: 'Today is a big day for our tribe. The year ends.',

  framework: getCookie('framework') || 'symbols',
  pkgManager: getCookie('pkgManager') || 'npm',
  language: getCookie('language') || 'js',
  installTab: getCookie('installTab') || 'local',
  followingUser,
  selected,
  notifications: [
    // {
    //   title: '',
    //   message: '',
    //   type: ''
    // }
  ],

  sync: true,
  syncDesignSystem: true,
  syncState: true,
  syncComponents: true,
  syncPages: true,
  syncSnippets: true,
  syncSchema: true,
  chosenQueue: [],

  sharedLibrary: null,

  user: {
    smblsFromLocal: getCookie('smblsFromLocal') === 'true',
    topNavbarActive: getCookie('topNavbarActive') !== 'false',
    bottomNavbarActive: getCookie('bottomNavbarActive') === 'true',
    allowTitleOnArtboard: getCookie('allowTitleOnArtboard') !== 'false',
    autoSaveSettings: getCookie('autoSaveSettings') !== 'false',
    isSidebarSticky: getCookie('isSidebarSticky') === 'true',
    autoCleanConsole: getCookie('autoCleanConsole') === 'true',
    componentShowFilter: getCookie('componentShowFilter') || 'all',
    navbarPlacement: getCookie('navbarPlacement') || 'right',
    presentMode: getCookie('presentMode') !== 'false',
    showErrorBanner: getCookie('showErrorBanner') !== 'false',
    thumbnailPreview: getCookie('thumbnailPreview') === 'true',
    optimizedMode: getCookie('optimizedMode') === 'true',
    showGrid: getCookie('showGrid') === 'true',
    explorerAutoscroll: getCookie('explorerAutoscroll') !== 'false',
    debuggingMode: getCookie('debuggingMode') === 'true',
    useGlassmorphism: getCookie('useGlassmorphism') !== 'false',
    allowAutoPosition: getCookie('allowAutoPosition') !== 'false',
    allowInitialSelection: getCookie('allowInitialSelection') !== 'false',
    allowTabs: getCookie('allowTabs') !== 'false',
    showReferences: getCookie('showReferences') !== 'false',
    allowTeamCursors: getCookie('allowTeamCursors') !== 'false',
    allowFilesidebarPreview: getCookie('allowFilesidebarPreview') !== 'false',
    allowTabPreview: getCookie('allowTabPreview') !== 'false',
    useAnimations: getCookie('useAnimations') !== 'false',
    allowZoombar: getCookie('allowZoombar') !== 'false',
    zoomLevel: getCookie('zoomLevel') || 1,
    assistant: getCookie('assistant') !== 'false',
    openOnDblClick: getCookie('openOnDblClick') === 'true',
    autoSelectSidebar: getCookie('autoSelectSidebar') === 'true',
    allowCanvasReplaceRouter: getCookie('allowCanvasReplaceRouter') !== 'false',
    languageDirection: getCookie('languageDirection') || 'ltr',
    editorPanelsAtRight: getCookie('editorPanelsAtRight') === 'true'
  },

  sharedLibraries: [],

  clients: {
    localhost: {},
    cli: {},
    platform: {}
  },
  seats: 1,
  loading: true
}

export const globalState = state

export const optionsState = state

export default state
